import type { AllFeatureIds } from 'generated/featureIds.generated'

import features, { type Features } from 'modules/core/store/collections/features'

export const enabledFeatureFlags = () => {
  return features.filter((f) => f.attributes.enabled).map((f) => `${f.attributes.id}`)
}

const pureHasFeature = (features: Features, id: AllFeatureIds) => {
  const item = features.find({
    id,
  })

  return item ? item.attributes.enabled : false
}

/**
 * @deprecated Please use GraphQL's `features.featuresConnection` instead
 */
export default function hasFeature(id: AllFeatureIds): boolean {
  return pureHasFeature(features, id)
}
